import { getSchemaURL, getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { VEHICLE_DETAILS } = ANALYTICS_CATEGORIES;

interface ProAccountPagesContext {
	selected_site_ids: number[];
	total_site_count: number;
}

const getProAccountPagesContext = (selectedSiteIds: number[], totalSiteCount: number) => [
	{
		data: { selected_site_ids: selectedSiteIds, total_site_count: totalSiteCount } satisfies ProAccountPagesContext,
		schema: getSchemaURL(SNOWPLOW_EVENTS.PRO_ACCOUNT_PAGES),
	},
];

interface GroupStructureVehicleDetailsEventContext {
	authorizedDealerIds: number[];
	totalSiteCount: number;
}

export const triggerGroupStructureSoldVdpAccessedEvent = ({
	authorizedDealerIds,
	totalSiteCount,
}: GroupStructureVehicleDetailsEventContext): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DETAILS,
		context: getProAccountPagesContext(authorizedDealerIds, totalSiteCount),
		name: 'dlr_gs_sold_vdp_accessed',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
